import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play--white",
  "use": "icon-play--white-usage",
  "viewBox": "0 0 51 58",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51 58\" id=\"icon-play--white\"><path d=\"M50 27.268c1.333.77 1.333 2.694 0 3.464L3.5 57.58c-1.333.77-3-.193-3-1.732V2.153C.5.613 2.167-.349 3.5.421L50 27.268Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol